export default "__VITE_ASSET__BZcZK8J7__"